import React, { useState, useEffect } from 'react';
import isBoolean from 'lodash/isBoolean';
import noop from 'lodash/noop';
import { CheckboxInput, CheckboxInputProps } from '@dealroadshow/uikit-checkbox';

interface IProps extends Omit<CheckboxInputProps, 'value'> {
  initialValue: boolean | undefined,
  value: boolean | undefined,
  onChange: (value: boolean) => void,
}

const indeterminateValue: boolean | undefined = undefined;

const IndeterminateCheckbox = (props: IProps) => {
  const [value, setValue] = useState(props.value);

  const [isSupportIndeterminate, setIsSupportIndeterminate] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const [isChecked, setIsChecked] = useState<boolean | undefined>(false);

  useEffect(() => {
    setIsSupportIndeterminate(!isBoolean(props.initialValue));
    setIsIndeterminate(!isBoolean(props.value));
    setIsChecked(isBoolean(props.value) ? props.value : indeterminateValue);
    setValue(props.value);
  }, [props.initialValue, props.value]);

  const handleNextValue = (): boolean | undefined => {
    if (isChecked === indeterminateValue) {
      setIsIndeterminate(false);
      setIsChecked(true);
      return true;
    }

    setIsIndeterminate(!isChecked);
    setIsChecked(isChecked ? false : indeterminateValue);

    return isChecked ? false : indeterminateValue;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).checked);
    props.onChange && props.onChange((event.target as HTMLInputElement).checked);
  };

  const handleClick = (event: React.MouseEvent<Element>) => {
    // Just to handle indeterminate checkboxes change in IE11
    if (!(event.target as HTMLInputElement).checked && isIndeterminate) {
      setIsIndeterminate(false);
      setIsChecked(true);
      setValue(true);
    }
  };

  const inputProps = {
    value,
    onChange: handleChange,
    onBlur: noop,
    onFocus: noop,
  };

  return (
    // @ts-ignore
    <CheckboxInput
      { ...props }
      input={ inputProps }
      // @ts-ignore
      supportIndeterminate={ isSupportIndeterminate }
      indeterminate={ isIndeterminate }
      checked={ isChecked }
      // @ts-ignore
      value={ isChecked }
      nextValue={ handleNextValue as () => boolean }
      onClick={ handleClick }
    />
  );
};

export default IndeterminateCheckbox;
